import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ServerCrash } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { GeneralSettingsModel } from '@/common/models/generalSettings'
import { api, ApiError } from '@/lib/axios'

async function getActiveGeneralSettings(): Promise<GeneralSettingsModel> {
  const { data } = await api.backend.get<GeneralSettingsModel[]>(
    '/general-configuration/findAll',
    {
      params: {
        relations: {
          where: {
            isActive: true,
          },
        },
      },
    },
  )

  return data[0]
}

export function useActiveGeneralSettings() {
  const { t } = useTranslation('settings')

  const { data, isPending, error } = useQuery<
    GeneralSettingsModel,
    AxiosError<ApiError>
  >({
    queryKey: ['active-general-settings'],
    queryFn: getActiveGeneralSettings,
  })

  useEffect(() => {
    if (!error) return

    toast(Toast, {
      data: {
        type: 'danger',
        icon: ServerCrash,
        title: t('general.use_active_general_settings.toast_error.title'),
        description:
          error?.response?.data?.friendlyMessage ||
          t('general.use_active_general_settings.toast_error.description'),
      },
    })
  }, [error, t])

  return {
    settings: data,
    isLoadingSettings: isPending,
  }
}
